import { Point } from 'geojson'
import { cellToParent, geometryToCells, getCellPolygon, getResolution } from 'quadbin'
import { MapViewState } from '@deck.gl/core'
import distance from '@turf/distance'
import { point } from '@turf/helpers'

export const scaleUpToParentResolutionLevel = ({ quadbin, resolution }: { quadbin: bigint; resolution: number }) => {
  const sourceQuadbinResolution = Number(getResolution(quadbin))
  const numberOfParentsBetweenSourceAndTile = Math.round(sourceQuadbinResolution - resolution)
  if (numberOfParentsBetweenSourceAndTile <= 0) return quadbin

  let transformedQuadbin = quadbin
  for (let i = 0; i < numberOfParentsBetweenSourceAndTile; i++) transformedQuadbin = cellToParent(transformedQuadbin)
  return transformedQuadbin
}

export function getApproximateQuadbinCellSizeKm({
  mapState,
  aggregationResLevel
}: {
  mapState: MapViewState
  aggregationResLevel: number
}) {
  const { longitude, latitude, zoom } = mapState
  const viewCenterPoint: Point = {
    type: 'Point',
    coordinates: [longitude, latitude]
  }

  const resolution = Math.ceil(zoom + aggregationResLevel)

  const quadbin = geometryToCells(viewCenterPoint, BigInt(resolution))

  const geometry = getCellPolygon(quadbin[0], 1)
  const from = point(geometry.slice(0, 2))
  const to = point(geometry.slice(2, 4))

  return distance(from, to, { units: 'kilometers' })
}
